<template>
  <div class="container " style="margin-bottom: 30px;">
    <div class="pro-container">
      <div class="pro-wrapper">
        <div class="pro-bar clearfix"><span class="pro-title">精彩展示</span></div>
        <ul class="pro-product-label clearfix">
          <li v-for="item in picCategoryList">
            <span
              class=""
              :class="{ active: item.picturesCategoryId == picturesCategoryId }"
              @click="
                pageNo = 1;
                picturesCategoryId = item.picturesCategoryId;
              "
              >{{ item.categoryName }}</span
            >
          </li>
        </ul>
        <div class="pro-product-body clearfix">
          <div class="">
            <ul class="imglist clearfix" style="width: 100%;">
              <li v-for="item in picList">
                <a class="">
                  <!---->
                  <div class="hot-product-img">
                    <!----><img
                      data-src="http://ppt.beegoedu.com/Upload/goods/20211029190430T6G.jpg?x-oss-process=image/resize,m_fill,w_260,h_130"
                      :src="item.picturesImage"
                      lazy="loaded"
                      style=""
                    />
                  </div>
                  <!-- <h3 class="hot-product-title">{{item.picturesTitle}}</h3><span
										class="hot-product-type">【{{item.picturesSubTitle}}】</span> -->
                </a>
              </li>
              <li v-for="item in 4-picList.length%4" v-if="picList.length%4!=0"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="page-wrap">
      <div class="page-content">
        <span class="iPre" @click="handlePrev()">
          上一页
        </span>

        <a
          class=""
          :class="{ curr: item == pageNo }"
          v-for="item in totalPage"
          @click="handlePage(item)"
          >{{ item }}</a
        >

        <span class="iNxt" @click="handleNext()">
          下一页
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      picCategoryList: [], //图集分类
      picturesCategoryId: -1, //图集分类id
      picList: [], //图集
      pageNo: 1,
      pageSize: 10,
      totalPage: 0
    };
  },
  methods: {
    getPicCategory() {
      this.$axios.get(this.$common.pictures_picturesCategoryList).then(res => {
        //   this.bannerList=res.data.data;
        this.picCategoryList = res.data.data.list;
        if (res.data.data.list.length > 0) {
          //	this.picturesCategoryId=res.data.data.list[0].picturesCategoryId
        }
      });
    },
    getPicList() {
      this.$axios
        .get(
          this.$common.pictures_pictureList +
            "?picturesCategoryId=" +
            this.picturesCategoryId +
            "&pageSize=" +
            this.pageSize +
            "&pageNo=" +
            this.pageNo
        )
        .then(res => {
          this.picList = res.data.data.list;
          this.totalPage = res.data.data.pages;
        });
    },
    handlePrev() {
      if (this.pageNo > 1) {
        this.pageNo--;
      }
      this.getPicList();
    },
    handleNext() {
      if (this.pageNo < this.totalPage) {
        this.pageNo++;
      }
      this.getPicList();
    },
    handlePage(page) {
      if (page == this.pageNo) {
        return;
      }
      this.pageNo = page;
      this.getPicList();
    }
  },
  created() {
    this.getPicCategory();
    this.picturesCategoryId = "1545323352539926528";
  },
  watch: {
    picturesCategoryId() {
      this.getPicList();
    }
  }
};
</script>

<style scoped>
.pro-wrapper {
  width: 1200px;
  margin: 0 auto;
}

.pro-wrapper .pro-bar {
  padding: 20px 30px;
  border-bottom: 1px solid #ccc;
}

.pro-message {
  padding-bottom: 40px;
}

.pro-wrapper .pro-bar .pro-title {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 0.2rem;
}

.pro-wrapper .pro-bar .pro-more {
  font-size: 1.8rem;
  float: right;
  margin-top: 15px;
}

.clearfix:after {
  content: "";
  display: block;
  clear: both;
}

.pro-message .pro-message-left {
  float: left;
  width: 580px;
}

.pro-message .pro-message-right {
  float: left;
  width: 580px;
  margin-left: 40px;
}

.pro-message .pro-message-left .pro-message-banner {
  width: 560px;
  height: 320px;
  margin: 25px 10px 10px 10px;
  border-radius: 10px;
  overflow: hidden;
}

.pro-message .pro-message-left .pro-message-banner img {
  width: 100%;
  height: 100%;
}

.pro-message .pro-message-right .pro-message-list {
  width: 560px;
  margin: 0 auto;
  padding-top: 30px;
}

.pro-message .pro-message-right .pro-message-list li a {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  text-decoration: none;
}

.pro-message .pro-message-right .pro-message-list li a span {
  font-size: 30px;
  vertical-align: middle;
  margin-right: 10px;
  color: #666;
}

.pro-wrapper .pro-bar .pro-more {
  font-size: 16px;
  float: right;
  margin-top: 15px;
}

.pro-product-label {
  padding: 10px;
}

.pro-product-label > li {
  float: left;
  position: relative;
  padding: 5px 0;
  width: 100px;
  margin: 0 5px;
  text-align: center;
  border-bottom: 3px solid transparent;
}

.pro-product-label > li > span {
  display: block;
  font-size: 18px;
  font-weight: 700;
  max-width: 100px;
  height: 21px;
  overflow: hidden;
  cursor: pointer;
}

.pro-product-label > li > .active {
  color: red;
}

.pro-product-body {
  padding-top: 10px;
}

.pro-product-body .float-left {
  float: left;
}

.pro-product-body .pro-product-banner {
  width: 260px;
  height: 460px;
  margin: 0 20px;
  border-radius: 10px;
  overflow: hidden;
}

.pro-product-body .pro-product-banner img {
  width: 100%;
}

.pro-product-body .float-right {
  float: right;
}

.pro-product-body .pro-product-list {
  width: 900px;
}

.pro-product-body .pro-product-list li {
  float: left;
  width: 260px;
  height: 210px;
  margin: 0 20px 40px 20px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 1px 1px 5px #ccc;
  background-color: #fff;
  position: relative;
}

.pro-product-body .pro-product-list li .hot-product-img {
  position: relative;
  width: 100%;
  height: 130px;
  overflow: hidden;
}

.pro-product-body .pro-product-list li .hot-product-img img {
  width: 100%;
}

.pro-product-body .pro-product-list li .hot-product-title {
  padding: 0 5px;
  height: 50px;
  line-height: 50px;
  color: #333;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.pro-product-body .pro-product-list li .hot-product-type {
  color: #999;
  font-size: 14px;
}

.pro-product-body .pro-product-list li .hot-product-price span {
  float: right;
  color: #ff6600;
  margin-right: 10px;
  margin-top: 2px;
  font-weight: 700;
  font-size: 13px;
}

a {
  text-decoration: none;
}

li {
  list-style: none;
}

.page-wrap {
  margin-top: 30px;
  margin-bottom: 30px;
  height: 36px;
  position: relative;
}

.page-wrap .page-content {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  height: 34px;
  line-height: 34px;
  font-size: 0;
  color: #555;
}

.page-wrap .page-content .iPre,
.page-wrap .page-content .iNxt {
  font-size: 14px;
  font-weight: normal;
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #e5e5e5;
}

.page-wrap .page-content .aPre,
.page-wrap .page-content .iPre {
  margin-right: 10px;
  cursor: pointer;
}

.page-wrap .page-content .curr {
  font-size: 14px;
  display: inline-block;
  padding: 0 15px;
  background-color: #555;
  border: 1px solid #555;
  color: #fff;
}

.page-wrap .page-content .aNxt,
.page-wrap .page-content .iNxt {
  margin-left: 10px;
  cursor: pointer;
}

.page-wrap .page-content a {
  font-size: 14px;
  display: inline-block;
  padding: 0 15px;
  border: 1px solid #e5e5e5;
  margin-left: -1px;
  cursor: pointer;
}

a {
  text-decoration: none;
}
.imglist {
  display: flex;
  flex-wrap: wrap;
  justify-content:  space-between;
  margin-bottom: 20px;
  align-content: space-between;
}
.imglist li {
  width: calc((100% - 60px)/4) !important;
  margin-bottom: 20px;
  height: 200px;
}
.imglist li a,.imglist li a img {
  width: 100% !important;
  height: 200px !important;
  object-fit: cover;
}
.hot-product-img {
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/piclist.vue